import MouseIcon from "common/svg/MouseIcon";
import Container from "./styled-components/Container";
import Description from "./styled-components/Description";

interface MouseIndicatorProps {
  description: string;
}

function ScrollIndicator({ description }: MouseIndicatorProps) {
  return (
    <Container>
      <Description>{description}</Description>
      <MouseIcon />
    </Container>
  );
}

export default ScrollIndicator;
